module.exports = __webpack_public_path__ + "img/zhiliang01.ac5de4d2.jpg";